import { Divider, Stack, Typography } from '@mui/material';
import { CfSearchInput } from '../../../../cf-ui/SearchInput/CfSearchInput';
import { CfContainedButton } from '../../../../cf-ui/buttons/CfContainedButton';
import { DeviceType, useBreakpoint } from '../../../../hooks/useBreakpoint';

interface ManageAccessTableHeaderProps {
  title: string;
  description: string;
  searchPlaceholder: string;
  setSearchParam?: React.Dispatch<React.SetStateAction<string>>;
  handleDialog: (showDialog: boolean) => void;
  isRecipeEditors?: boolean;
  isManageLocation?: boolean;
  isHiddenRecipes?: boolean;
  isSecretRecipes?: boolean;
}
export function ManageAccessTableHeader({
  description,
  handleDialog,
  setSearchParam,
  searchPlaceholder,
  title,
  isRecipeEditors,
  isManageLocation,
  isHiddenRecipes,
  isSecretRecipes,
}: ManageAccessTableHeaderProps): JSX.Element {
  const handleSearch = (searchValue: string) => {
    setSearchParam?.(searchValue);
  };
  const deviceType = useBreakpoint().deviceType;
  return (
    <Stack direction='column' width='100%'>
      <Stack
        sx={{
          display: 'flex',
          flexDirection: deviceType === DeviceType.Desktop ? 'row' : 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        gap={2}
        width='100%'
      >
        <Stack
          display='flex'
          flexDirection='column'
          alignItems='flex-start'
          width={deviceType === DeviceType.Desktop ? '50%' : '100%'}
        >
          <Typography variant='h1'>{title}</Typography>
          <Typography variant='responsiveParagraph'>{description}</Typography>
        </Stack>
        <Stack
          display='flex'
          flexDirection='row'
          alignItems='flex-end'
          gap={1}
          width={deviceType === DeviceType.Desktop ? '50%' : '100%'}
        >
          <CfSearchInput
            placeholder={searchPlaceholder}
            sx={{ width: '100%' }}
            onSubmit={handleSearch}
            onClear={() => setSearchParam?.('')}
          />
          <CfContainedButton
            sx={{ width: 'fit-content', whiteSpace: 'nowrap', px: { xs: 2, md: 4 } }}
            onClick={() => handleDialog(true)}
          >
            {deviceType === DeviceType.Mobile ? (
              'Manage'
            ) : (
              <>
                {isManageLocation && 'Manage location(s)'}
                {isRecipeEditors && 'Manage editor(s)'}
                {isHiddenRecipes && 'Manage hidden recipe(s)'}
                {isSecretRecipes && 'Manage secret recipe(s)'}
              </>
            )}
          </CfContainedButton>
        </Stack>
      </Stack>
      <Divider sx={{ borderBottomWidth: 4, my: 1 }} />
    </Stack>
  );
}
